import { render, staticRenderFns } from "./HCOSchema.vue?vue&type=template&id=4d544330&"
import script from "./HCOSchema.vue?vue&type=script&lang=ts&"
export * from "./HCOSchema.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports